module.exports = "<div class=\"row\">\n    <div class=\"col-md-12 text-left\">\n      <span class=\"title\">Últimos candidatos a mis ofertas</span>\n    </div>\n    <div class=\"col-md-12 text-left\">\n      <!-- <app-item-candidates></app-item-candidates> -->\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/last-candidates/last-candidates.component.html
// module id = ../../../../../src/app/pages/last-candidates/last-candidates.component.html
// module chunks = main